import React, {useState, useEffect} from 'react';

const spikeUrl = 'https://credex_los.4apply.com';

function Spike({
  data,
  inProgress,
  uuid,
  status,
  setBtnDisabled,
  setIframeMethodType,
}) {
  const [eventListener, setEventListener] = useState(false);
  const internalId = data?.kyc_external_id;
  const sessionToBeFinalized = data?.session_to_be_finalized || false;

  useEffect(() => {
    if (!eventListener && !inProgress) {
      window.addEventListener('message', event => {
        spikeListener(event, setBtnDisabled, setIframeMethodType);
      });

      setEventListener(true);
    }

    return () => {
      window.removeEventListener('message', event => {
        spikeListener(event, setBtnDisabled, setIframeMethodType);
      });
    };
  }, [inProgress, eventListener, setBtnDisabled, setIframeMethodType]);

  const controlByStatus = {
    awaiting_kyc: 'idcard',
    ocr: 'selfie',
    selfie: 'liveness',
    awaiting_anaf_consent: 'esign',
    awaiting_esign: 'esign',
  };

  const iframe = `
    <iframe
      src="${spikeUrl}/${controlByStatus[status]}?IdInternalRequest=${internalId}&IdExternalRequest=${uuid}&sessionToBeFinalized=${sessionToBeFinalized}"
      width="100%" height="100%" style="position: absolute; top: 0; left: 0;"
      allow="camera *;encrypted-media *;"
      id="kyc-spike"
    />
  `;

  return (
    <div
      dangerouslySetInnerHTML={{__html: iframe}}
      className="relative overflow-hidden w-full"
      style={{height: '0', paddingBottom: '100%'}}
    />
  );
}

function spikeListener(event, setBtnDisabled, setIframeMethodType) {
  if (event.origin !== spikeUrl) {
    return;
  }

  if (event.data.info === 'OK') {
    setIframeMethodType(event.data?.methodType);
    setBtnDisabled(false);
  }

  console.log('spikeListener=====', event.data);
}

export default Spike;
